module.exports = __webpack_public_path__ + "static/media/AvenirNext-DemiBold.c71557c3.eot";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/AvenirNext-DemiBold.eot
// module id = 82
// module chunks = 0